import { render, staticRenderFns } from "./IconOrder.vue?vue&type=template&id=3552cae0"
import script from "./IconOrder.vue?vue&type=script&lang=js"
export * from "./IconOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports